import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-work-devex-registration",
  templateUrl: "./work-devex-registration.component.html",
  styleUrls: ["./work-devex-registration.component.scss"],
})
export class WorkDevexRegistrationComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {}

  scroll(element: HTMLElement) {
    element.scrollIntoView();
  }
}



// WEBPACK FOOTER //
// ./src/app/work-devex-registration/work-devex-registration.component.ts